// extracted by mini-css-extract-plugin
export default {"permissions":"styles_permissions__oPN5q","pageTitle":"styles_pageTitle__8IFAN","contentWrap":"styles_contentWrap__8tibK","contentTitle":"styles_contentTitle__z3ZYA"};